const State = {
  activeUser: {}
};
export default State;
